module.exports = __webpack_public_path__ + "static/media/instagram.ae0aab34.svg";